import { createAsyncThunk } from '@reduxjs/toolkit';
import { siteService, workerService } from 'services';
import {
  GetUserSiteShopListError,
  GetUserSiteShopListRequest,
  GetUserSiteShopListResponse,
  GetWorkerError,
  GetWorkerRequest,
  GetWorkerResponse,
  ThunkAPI,
} from 'types';

export const getWorkerShift = createAsyncThunk<
  GetWorkerResponse,
  GetWorkerRequest,
  ThunkAPI<GetWorkerError>
>('tableGantt/thunk/getWorkerShift', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getWorkerShift(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getSiteShopList = createAsyncThunk<
  GetUserSiteShopListResponse,
  GetUserSiteShopListRequest,
  ThunkAPI<GetUserSiteShopListError>
>('tableGantt/thunk/site/shop_list', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteShopList(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
